import { bunja } from 'bunja';
import { atom } from 'jotai';

import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';

import { updateV2SocketData } from './internal/v2-helper';
import { r230522SocketBunja } from './socket';
import { tickersBunja } from './tickers';
import { WsV2TableEvent } from './types';

type SnapshotPswapTicker = Record<string, PswapTicker>;
export type PswapTickers = SnapshotPswapTicker | null;

export interface PswapTicker {
  indexPrice: string;
  priceChange24h: string;
  high24h: string;
  low24h: string;
  volume24h: string;
  openInterest: string;
  openInterestInUsdt: string;
  // 중복
  midPrice: string;
  markPrice: string;
  fundingRate: string;
  fundingTime: string;
  priceChangePct24h: string;
  turnover24h: string;
}

const checkDiffTicker = (prev: SnapshotPswapTicker, next: SnapshotPswapTicker) => {
  return Object.entries(next).some(([symbol, ticker]) => {
    return Object.entries(ticker).some(([key, value]) => value !== prev[symbol]?.[key as keyof PswapTicker]);
  });
};

function updateTickers(prev: PswapTickers, wsData: WsV2TableEvent<PswapTicker>['data']) {
  const prevTickers = prev || {};
  if (wsData.s && checkDiffTicker(prevTickers, wsData.s)) {
    return updateV2SocketData(prevTickers, wsData);
  }
  return prevTickers;
}

const pswapTickersAtom = atom<PswapTickers>(null);
export const pswapTickersBunja = bunja(() => {
  const { r230522Socket } = bunja.use(r230522SocketBunja);
  const store = bunja.use(JotaiStoreScope);
  const { setCurrentPswapTicker } = bunja.use(tickersBunja);
  function setCurrentTicker(ticker: string | null = null) {
    setCurrentPswapTicker(ticker);
  }

  bunja.effect(() => {
    function handler(event: WsV2TableEvent<PswapTicker>) {
      if (!event.data) return;
      store.set(pswapTickersAtom, (prev) => updateTickers(prev, event.data));
    }

    r230522Socket.on('market/tickers', handler);

    return () => {
      setCurrentPswapTicker(null);
      r230522Socket.off('market/tickers', handler);
    };
  });

  return {
    pswapTickersAtom,
    setCurrentTicker,
  };
});
pswapTickersBunja.debugLabel = 'pswapTickersBunja';
